module.exports = __webpack_public_path__ + "img/afdeed7.svg";